import { createFileRoute } from '@tanstack/react-router'
import { MicroFrontendErrorBoundary, RemoteLoader } from '@/components/micro-frontend'
import { Main } from '@/components/layout/main'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@workspace/ui/components/card'

export const Route = createFileRoute(
  '/_authenticated/_organization/apps/skeleton-demo'
)({
  component: SkeletonDemoPage,
})

function SkeletonDemoPage() {
  return (
    <Main className='flex flex-1 flex-col gap-6'>
      <Card>
        <CardHeader>
          <CardTitle>Micro Frontend Demo</CardTitle>
          <CardDescription>
            This page demonstrates loading the skeleton micro frontend from a
            remote server via Module Federation.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className='rounded-lg border p-4'>
            <MicroFrontendErrorBoundary remoteName='skeleton'>
              <RemoteLoader remoteName='skeleton' moduleName='App' />
            </MicroFrontendErrorBoundary>
          </div>
        </CardContent>
      </Card>
    </Main>
  )
}

